<script>
  import { fade } from 'svelte/transition'
  import BaseDonut from '../core/dataviz/BaseDonut.svelte'
  import IntersectionObserver from '../util/IntersectionObserver.svelte'
  // import JsonDebug from '../../../utilities/JsonDebug.svelte'

  export let store
  $: storeValue = $store || undefined
  export let value = $store
  export let min = 0

  export let max = 100
  export let suffix = ''
  export let isDecimal = false

  let dialStartAngle = 90
  let dialEndAngle = 89.999

  let once = true
</script>

<IntersectionObserver class="" let:intersecting once bottom={ 500 }>
  { #if intersecting }
    <div class="p-4" in:fade={{ delay:150 }}>
      <BaseDonut value={ storeValue || value } displayValue={ false } min={ min } max={ max } dialStartAngle={ dialStartAngle } dialEndAngle={   dialEndAngle }  suffix={ suffix } isDecimal={ isDecimal } />
    </div>
  { :else }
    <div style="min-height: 400px;"></div>  
  { /if }
</IntersectionObserver>